import React from 'react';
import { Grid } from '@mui/material';
import { Field } from 'formik';
import HdFormikTextField from '../../../../form/formik/components/text-field/HdFormikTextField';
import HdFormControl from '../../../../form/components/form-control/HdFormControl';

export default function BlackHole() {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <HdFormControl>
            <Field
              name='queryLatency'
              label='Query latency'
              helperText='Mock latency to be added to the queries'
              required
              component={HdFormikTextField}
            />
          </HdFormControl>
        </Grid>
      </Grid>
    </>
  );
}
